import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/auth';
import { Button, Section, SectionHeading, accent, cn } from '../ui';

/**
 * The one inverted band on the home page.
 *
 * Everything above it is off-white or a soft tint, so dropping to the deep ink
 * surface here makes the closing ask the loudest thing on the page without
 * needing a bigger heading or a louder button. `Section tone="ink"` flips the
 * heading and eyebrow colours with the surface; the copy below states the
 * remaining ones explicitly so nothing inherits an unreadable pairing.
 */
const CallToAction = () => {
  const navigate = useNavigate()
  const { currentUser } = useAuth()

  const isSignedIn = Boolean(currentUser?._id);

  return (
    <Section tone="ink">
      <div className="mx-auto max-w-4xl text-center">
        <span
          aria-hidden="true"
          className={cn('mx-auto mb-10 block h-1 w-16 rounded-sm', accent('gold').rule)}
        />

        <SectionHeading
          align="center"
          inverted
          className="mb-0"
          eyebrow="Get started"
          eyebrowAccent={accent('gold').rule}
          title="Start Your Academic Journey Today"
          description="Join thousands of students and scholars who are expanding their knowledge, collaborating on research, and advancing their careers."
          action={
            <div className="flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4">
              {!isSignedIn && (
                // A blue fill on the ink surface would sit at barely 2:1 against
                // the band, so the button gets a faint white edge to keep its
                // shape visible. The label itself is white on blue and clears
                // 4.5:1 either way.
                <Button
                  size="lg"
                  onClick={() => navigate("/auth")}
                  trailingIcon={<ArrowRight size={18} aria-hidden="true" />}
                  className="w-full border border-white/25 sm:w-auto"
                >
                  Create account
                </Button>
              )}
              {/* Only ever one primary here: once you are signed in, browsing
                  courses is the action that matters. */}
              <Button
                size="lg"
                variant={isSignedIn ? 'primary' : 'secondary'}
                onClick={() => navigate("/courses")}
                className={cn('w-full sm:w-auto', isSignedIn && 'border border-white/25')}
              >
                Explore courses
              </Button>
            </div>
          }
        />
      </div>
    </Section>
  );
};
export default CallToAction
